export default [
    {
        path: '/index',
        name: 'index',
        meta: {
            title: '首页',
            noheader: true,
            unPullRefresh: true,
            pl0: true,
            pr0: true,
            hasBottom: true,
            keepAlive:true
        },
        component: () => import('./HomePage')
    },
    {
        path: '/history',
        name: 'history',
        meta: {
            title: '历史提现榜',
            noheader: true,
            unPullRefresh: true,
            pl0: true,
            pr0: true,
            // hasBottom: true
        },
        component: () => import('./HistoryList')
    },
    {
        path: '/real',
        name: 'real',
        meta: {
            title: '实时提现榜',
            noheader: true,
            unPullRefresh: true,
            pl0: true,
            pr0: true,
            // hasBottom: true
        },
        component: () => import('./RealList')
    },
    {
        path: '/resultSearch',
        name: 'resultSearch',
        meta: {
            title: '搜索结果',
            noheader: true,
            unPullRefresh: true,
            pl0: true,
            pr0: true,
            noBottom: true,
            white: true
        },
        component: () => import('./ResultSearch')
    },
    {
        path: '/detail',
        name: 'detail',
        meta: {
            title: '游戏详情',
            unPullRefresh: true,
            pl0: true,
            pr0: true,
            header2: true,
            // noBottom: true
        },
        component: () => import('./GameDetail')
    },
    // 游戏排行
    {
        path: '/rank/:sort',
        name: 'rank',
        meta: {
            title: '排行',
            noBottom:true,
            header2: true,
            pl0:true,
            pr0:true,
            white:true,
            unPullRefresh: true,
        },
        component: () => import('./Rank')
    }
]